<ng-template #defaultTabButtons let-c="close" let-d="dismiss">

    <div class="backgroundTable text-white" ngbAutofocus>
        <div class=" mx-5 ">
            <div class="row my-2">
              <div class="col-9 align-self-center p-2 bd-highlight">Cerrar proyecto</div>

              <div class="col-3 d-flex flex-row-reverse bd-highlight p-2 "><button type="button" ngbAutofocus aria-label="Close"  (click)="d('Cross click')" class="btn btn-outline-danger "><i class="fa-solid fa-xmark fa-xl"></i></button></div>
            </div>
          </div>
    <div class="componente-importantes-from p-3">
        <table class="table componente-importantes text-white " style="font-size: 12px;">
            <!-- REFERENCIA 1 -->
            <tr>
                <th class="pt-3" colspan="2">
                    <span class="h5">Etapa/s
                        <span *ngIf="listStage.length==0"> <i class="fa-solid fa-check" style="color: green;"></i></span>
                        <span *ngIf="listStage.length!=0"> <i class="fa-solid fa-x" style="color: red;"></i></span>
                        </span>
                </th>

            </tr>
            <br>

            <tr *ngFor="let item of listStage"  >
                <td class="text-start">
                   <span style="font-size: 18px;">{{item.name}}</span>
                </td>

                <td >
                    <div class="p-2 bd-highlight d-flex flex-column">
                        <span *ngIf="item.stado === 'PENDIENTE'"
                          class="badge rounded-pill text-bg-warning p-2" style="font-size: 12px;">{{item.stado}}</span>
                        <span *ngIf="item.stado === 'EN CURSO'"
                          class="badge rounded-pill text-bg-success p-2 " style="font-size: 12px;">{{item.stado}}</span>
                    </div>

                </td>
            </tr>
            <!-- REFERENCIA 2 -->
                        <!-- REFERENCIA 1 -->
            <tr>
                <th class="pt-3" colspan="2">
                    <span class="h5">Sprint/s
                        <span *ngIf="listSprint.length==0"> <i class="fa-solid fa-check" style="color: green;"></i></span>
                        <span *ngIf="listSprint.length!=0"> <i class="fa-solid fa-x"> style="color: red;"</i></span>
                        </span>
                </th>

            </tr>
            <br>

            <tr *ngFor="let item of listSprint"  >
                <td class="text-start">
                   <span style="font-size: 18px;">{{item.name}}</span>
                </td>

                <td >
                    <div class="p-2 bd-highlight d-flex flex-column">
                        <span *ngIf="item.stado === 'PENDIENTE'"
                          class="badge rounded-pill text-bg-warning p-2" style="font-size: 12px;">{{item.stado}}</span>
                        <span *ngIf="item.stado === 'EN CURSO'"
                          class="badge rounded-pill text-bg-success p-2 " style="font-size: 12px;">{{item.stado}}</span>
                    </div>

                </td>
            </tr>
            <!-- REFERENCIA 2 -->

            <tr>
                <th class="pt-3" colspan="2">
                    <span class="h5">Asignacion/es
                        <span *ngIf="listAssignment.length==0"> <i class="fa-solid fa-check" style="color: green;"></i></span>
                        <span *ngIf="listAssignment.length!=0"> <i class="fa-solid fa-x" style="color: red;"></i></span>
                        </span>
                </th>

            </tr>
            <br>

            <tr *ngFor="let item of listAssignment"  >
                <td class="text-start">
                   <span style="font-size: 18px;">{{item.username}}</span>
                </td>

                <td >
                    <div class="p-2 bd-highlight d-flex flex-column">
                        <span *ngIf="item.stado === 'PENDIENTE'"
                          class="badge rounded-pill text-bg-warning p-2" style="font-size: 12px;">{{item.stado}}</span>
                        <span *ngIf="item.stado === 'EN CURSO'"
                          class="badge rounded-pill text-bg-success p-2 " style="font-size: 12px;">{{item.stado}}</span>
                    </div>

                </td>
            </tr>

            <tr>
                <th class="pt-3" colspan="2">
                    <span class="h5">Riesgo/s
                <span *ngIf="listRisk.length==0"> <i class="fa-solid fa-check" style="color: green;"></i></span>
                <span *ngIf="listRisk.length!=0"> <i class="fa-solid fa-x" style="color: red;"></i></span>
                </span>
                </th>

            </tr>
            <br>

            <tr *ngFor="let item of listRisk"  >
                <td class="text-start">
                   <span style="font-size: 18px;">{{item.name}}</span>
                </td>

                <td >
                    <div class="p-2 bd-highlight d-flex flex-column">
                        <span *ngIf="item.stado === 'PENDIENTE'"
                          class="badge rounded-pill text-bg-warning p-2" style="font-size: 12px;">{{item.stado}}</span>
                        <span *ngIf="item.stado === 'EN CURSO'"
                          class="badge rounded-pill text-bg-success p-2 " style="font-size: 12px;">{{item.stado}}</span>
                    </div>

                </td>
            </tr>

            <tr>
                <th class="pt-3" colspan="2">
                <span class="h5">Hito/s
                <span *ngIf="listMilestone.length==0"> <i class="fa-solid fa-check" style="color: green;"></i></span>
                <span *ngIf="listMilestone.length!=0"> <i class="fa-solid fa-x" style="color: red;"></i></span>
                </span>
                </th>

            </tr>
            <br>

            <tr *ngFor="let item of listMilestone"  >
                <td class="text-start">
                   <span style="font-size: 18px;">{{item.title}}</span>
                </td>

                <td >
                    <div class="p-2 bd-highlight d-flex flex-column">
                        <span *ngIf="item.stado === 'PENDIENTE'"
                          class="badge rounded-pill text-bg-warning p-2" style="font-size: 12px;">{{item.stado}}</span>
                        <span *ngIf="item.stado === 'EN CURSO'"
                          class="badge rounded-pill text-bg-success p-2 " style="font-size: 12px;">{{item.stado}}</span>
                    </div>

                </td>
            </tr>

            <tr >
                <th class="pt-3" colspan="2">
                    <span class="h5">Pago/s
                        <span *ngIf="listPayment.length==0"> <i class="fa-solid fa-check" style="color: green;"></i></span>
                        <span *ngIf="listPayment.length!=0"> <i class="fa-solid fa-x" style="color: red;"></i></span>
                        </span>
                </th>
                <th></th>

            </tr>
            <br>
            <tr *ngFor="let item of listPayment">
                <td class="text-start">
                   <span  style="font-size: 18px;">{{item.title}} </span>
                </td>
                <td>
                    <div class="p-2 bd-highlight d-flex flex-column">
                        <span *ngIf="item.stado === 'PENDIENTE'"
                          class="badge rounded-pill text-bg-warning p-2" style="font-size: 12px;">{{item.stado}}</span>
                        <span *ngIf="item.stado === 'EN CURSO'"
                          class="badge rounded-pill text-bg-success p-2 " style="font-size: 12px;">{{item.stado}}</span>
                    </div>
                </td>


            </tr>

        </table>


        </div>
        <div class="row my-3">
            <div class="col-12 text-center">
                <button [disabled]="!(listStage.length==0 && listSprint.length==0 && listAssignment.length==0 && listRisk.length==0 && listMilestone.length==0 && listPayment.length==0)"
                type="button" class="btn btn-outline-light" (click)="closeProject()">Cerrar proyecto</button>
            </div>
        </div>

    </div>



</ng-template>
